import { gql, useQuery } from "@apollo/client";
import { createContext } from "react";

export const OdooContext = createContext({});

const FETCH_ODOO_URL = gql`
  query FETCH_ODOO_URL {
    odooUrl
    odooUrlInc: odooUrl(instance: "INC")
  }
`;

const OdooProvider = ({ children }) => {
  const fetchOdooUrl = useQuery(FETCH_ODOO_URL);
  const odooUrl = fetchOdooUrl.data ? fetchOdooUrl.data.odooUrl : null;
  const odooUrlInc = fetchOdooUrl.data ? fetchOdooUrl.data.odooUrlInc : null;

  return (
    <OdooContext.Provider value={{ odooUrl, odooUrlInc }}>
      {children}
    </OdooContext.Provider>
  );
};

export default OdooProvider;
